import { render, staticRenderFns } from "./puOnStorageAction.vue?vue&type=template&id=69230141&scoped=true"
import script from "./puOnStorageAction.vue?vue&type=script&lang=js"
export * from "./puOnStorageAction.vue?vue&type=script&lang=js"
import style0 from "./puOnStorageAction.vue?vue&type=style&index=0&id=69230141&prod&scoped=true&lang=css"
import style1 from "./puOnStorageAction.vue?vue&type=style&index=1&id=69230141&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69230141",
  null
  
)

export default component.exports